import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ignoreResizeObserverErrors } from './utils/errorHandler';

// Call the error handler function
ignoreResizeObserverErrors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);